/**
 * Show
 */
export function show() {
    return {
        type: 'SIDEBAR_SHOW',
        payload: true
    };
}

/**
 * Hide
 */
export function hide() {
    return {
        type: 'SIDEBAR_HIDE',
        payload: false
    };
}


// WEBPACK FOOTER //
// ./src/actions/sidebar.js